import { FC } from "react";
import { NavLink } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Grid } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import uploadfile from "../../assets/images/icons/uploadfile.svg";
import mobile from "../../assets/images/icons/mobile.svg";
import camera from "../../assets/images/icons/camera.svg";
import { Formik, Form } from "formik";
import { Button } from "@material-ui/core";
import verifyfailed from "../../assets/images/icons/verify-failed.svg";
import verifysuccess from "../../assets/images/icons/verify-success.svg";
import {CaptureTypeStyle} from "../Styles/IdentityVerificationStyles";

const INITIAL_FORM_STATE = {
  radioselect: "",
};
const CaptureType:FC = () => {
  const theme = useTheme();
  const classes = CaptureTypeStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const radio = () => {};

  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      <Formik
        initialValues={{
          ...INITIAL_FORM_STATE,
        }}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <Grid className="mb-12">
              <Box mb={1.5}>
                <Typography variant="h3" color="secondary">
                  Submit Driver Liscense
                </Typography>
              </Box>
            </Grid>
            <Grid className="mb-12 mt-12" container spacing={isActive ? 2 : 3}>
              <Grid item md={2} sm={4} xs={12}>
                <div className="radiowrapper active">
                  <img src={camera} className="img-fluid" alt="camera" />
                  <input
                    type="radio"
                    name="radioselect"
                    onChange={radio}
                    checked
                  />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    Take Photo
                  </Typography>
                </div>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <div className="radiowrapper">
                  <img
                    src={uploadfile}
                    className="img-fluid"
                    alt="uploadfile"
                  />
                  <input type="radio" name="radioselect" />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    Upload File
                  </Typography>
                </div>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <div className="radiowrapper">
                  <img src={mobile} className="img-fluid" alt="mobile" />
                  <input type="radio" name="radioselect" />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    Use Your Mobile
                  </Typography>
                </div>
              </Grid>
            </Grid>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isActiveXS ? "space-between" : ""}
              mt={isActiveXS ? 2 : 5}
            >
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                Next
              </Button>
              <Button
                className="socialbtn"
                variant="outlined"
                color="secondary"
                size="large"
              >
                Back
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
      {/* verifcation failed */}
      <Box my={3}>
      <Typography variant="h3" color="secondary">
            Below screens come on different scenarios after integrations
          </Typography>
      </Box>
      <Box>
        <img src={verifyfailed} className="img-fluid" alt="verifyfailed" />
        <Box mt={3} mb={1.5}>
          <Typography variant="h3" color="secondary">
            Failed to Verify
          </Typography>
        </Box>
        <Box mb={0.5}>
          <Typography variant="body1" className="fw-bold text-danger">
            Try again or contact support if you are experiencing a technical
            problem.
          </Typography>
        </Box>
        <Typography variant="body1" className="fw-normal">
          You can get in touch with{" "}
          <NavLink className="text-darkslate fw-bold" to="#">
            Support
          </NavLink>
        </Typography>
        <Box mt={isActiveXS ? 4 : 7} className="longbtn">
          <Button variant="contained" color="secondary" size="large">
            try again
          </Button>
        </Box>
      </Box>
      {/* verifcation completed */}
      <Box>
        <img src={verifysuccess} className="img-fluid" alt="verifysuccess" />
        <Box mt={3} mb={1.5}>
          <Typography variant="h3" color="primary">
          Great All Done!
          </Typography>
        </Box>
        <Typography variant="body1" className="fw-bold">
        You have successfully completed the process
        </Typography>
        <Box mt={5} className="longbtn">
          <Button variant="contained" color="secondary" size="large">
          Go to Dashboard
          </Button>
        </Box>
      </Box>
    </Box>
    
  );
};
export default CaptureType;
